'use client';

import * as React from 'react';

import { PricingTable } from '@workspace/billing/components/pricing-table';
import { APP_NAME } from '@workspace/common/app';
import { Alert, AlertDescription } from '@workspace/ui/components/alert';

import { GridSection } from '~/components/fragments/grid-section';
import { SiteHeading } from '~/components/fragments/site-heading';

export function PricingHero(): React.JSX.Element {
  return (
    <GridSection>
      <div className="container space-y-12 py-20">
        <SiteHeading
          badge="Preise"
          title="Preise für dein Unternehmen"
          description={`Von Start-ups bis hin zu wachsenden Unternehmen – ${APP_NAME} bietet für jeden die passende Lösung.`}
        />
        <Alert variant="default" className="bg-primary/10 border-primary/20">
          <AlertDescription className="text-center text-base">
            <strong>🎉 Lifetime Deal:</strong> Nur während der Beta verfügbar! Sichere dir jetzt lebenslangen Zugang zu einem einmaligen Preis.
          </AlertDescription>
        </Alert>
        <PricingTable />
      </div>
    </GridSection>
  );
}
